import { render, staticRenderFns } from "./ProjectForm.vue?vue&type=template&id=857dc952&scoped=true&lang=pug&"
import script from "./ProjectForm.vue?vue&type=script&lang=ts&"
export * from "./ProjectForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectForm.vue?vue&type=style&index=0&id=857dc952&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857dc952",
  null
  
)

export default component.exports